
import {
  createModule,
  
} from 'yoshi-flow-bm-runtime';
const createBILogger = undefined;
import type { ModuleLite } from 'yoshi-flow-bm-runtime/common';

createModule({
  module: {
    module: {"moduleId":"PROMOTE_MARKETING_TOOLS","config":{"moduleId":"PROMOTE_MARKETING_TOOLS","routeNamespace":"promote-marketing-tools","isCoreService":true,"translations":{"enabled":true,"suspense":true},"sentry":{"DSN":"https://ff785244f6e944e98522ee2c0b8b3a41@sentry.wixpress.com/1336","id":"ff785244f6e944e98522ee2c0b8b3a41","projectName":"promote-marketing-tools","teamName":"promote"},"experiments":{"scopes":["promote-marketing-tools"]},"bi":"@wix/bi-logger-promote-connect","enabledByExperiments":["specs.promote.promote-marketing-tools.bm-module"],"topology":{"staticsUrl":{"artifactId":"com.wixpress.promote-marketing-tools"}},"moduleBundleName":"module"},"fedopsPath":"/home/builduser/agent00/work/d0e195c9c024b130/promote-marketing-tools/fedops.json"} as ModuleLite,
    
    
  },
  pages: [
    
  ],
  exportedComponents: [
    
  ],
  useEssentials: false,
  methods: [
    
  {
    method: {"methodId":"promoteMarketingTools.getChannelsPermitted"},
    fn: () => require('/home/builduser/agent00/work/d0e195c9c024b130/promote-marketing-tools/src/methods/getChannelsPermitted').default,
  },

  {
    method: {"methodId":"promoteMarketingTools.getPromotionTemplates"},
    fn: () => require('/home/builduser/agent00/work/d0e195c9c024b130/promote-marketing-tools/src/methods/getPromotionTemplates').default,
  },

  {
    method: {"methodId":"promoteMarketingTools.promoteInChannel"},
    fn: () => require('/home/builduser/agent00/work/d0e195c9c024b130/promote-marketing-tools/src/methods/promoteInChannel').default,
  },
  ],
  optionalDeps: {
    
    loadOptionalFlowAPIDeps: async () => (await import(/* webpackChunkName: "flowAPIDeps" */ '../flowAPIDeps')).default,
    asyncMessagesLoader: (locale: string) => import(`/home/builduser/agent00/work/d0e195c9c024b130/promote-marketing-tools/src/assets/locale/messages_${locale}.json`),
    createBILogger,
  },
});